import type { FC } from 'react';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useCountries } from '../../hooks';
import { Select, SelectProps } from '../atoms';

export const CountrySelector: FC<Omit<SelectProps, 'name'>> = props => {
  const { getValues, setValue } = useFormContext();
  const countries = useCountries();

  useEffect(() => {
    if (countries && countries.length > 0) {
      const initialValue = getValues('country');
      const selectedExists = countries.some(c => c.code === initialValue);
      
      if (selectedExists) {
        setValue('country', initialValue);
      } else {
        setValue('country', countries[0].code);
      }
    }
  }, [countries, getValues, setValue]);

  return (
    <Select
      {...props}
      block
      required
      label="country"
      name="country"
      options={countries?.map(country => ({
        label: country.name,
        value: country.code,
      }))}
    />
  );
};
